import React from 'react';
import DataTable from '../components/DataTable/DataTable';

const DashboardPage = () => {
  return (
    <div className="page-container">
      <DataTable limit={10} defaultSortKey="balance" defaultSortDirection="desc" showPagination />
    </div>
  );
};

export default DashboardPage;
